import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import Select from 'ati-ui-react/components/AtiSelect';
import { IPagination } from 'interfaces/IPagination';
import options from './options';
import {
  PaginationStepWrapper,
  PaginationStepSelectWrapper,
  PaginationStepHeader,
} from './PaginationStepStyles';

interface IPaginationStep {
  header?: string;
  pagination: IPagination;
}

const PaginationStep: FC<IPaginationStep> = observer(({ header, pagination }) => {
  return (
    <PaginationStepWrapper>
      {header && <PaginationStepHeader>{header}</PaginationStepHeader>}
      <PaginationStepSelectWrapper>
        <span className="prefix">по</span>
        <Select
          value={pagination.limit}
          options={options}
          onChange={(e: { value: number; label: string } | undefined) =>
            pagination.setLimit(e?.value)
          }
          clearable={false}
        />
      </PaginationStepSelectWrapper>
    </PaginationStepWrapper>
  );
});

export default PaginationStep;
